import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

export default {
  state:{
    userName:'',
    isLogin:false
  },
  actions,
  mutations,
  getters
}